import { z } from 'zod';
const unmetNeedsMetricsSchema = z.object({
    eligiblePatientCount: z.number(),
    criteriaMetPatientCount: z.number(),
    pct: z.number(),
});
const unmetNeedsRecSchema = z.object({
    definition: z.string(),
    eligiblePopulation: z.string(),
    identifier: z.string(),
    name: z.string(),
    metrics: unmetNeedsMetricsSchema.nullable(),
});
export const recommendationReasonSchema = z.object({
    reason: z.string(),
    items: z.array(z.string()),
    unmetNeeds: z.array(unmetNeedsRecSchema),
});
